export default {
  presets: {
    light: {
      primary: '#1D61FF',
      secondary: '#64748B',
      backgroundPrimary: '#FFFFFF',
      backgroundSecondary: '#F8FAFC',
      backgroundElement: '#F8FAFC',
      backgroundBorder: '#E2E8F0',
      backgroundCardPrimary: '#FFFFFF',
      backgroundCardSecondary: '#F8FAFC',
      textPrimary: '#0F172A',
      textSecondary: '#64748B',
      success: '#22C55E',
      info: '#3B82F6',
      danger: '#EF4444',
      warning: '#F59E0B',
    },
    dark: {
      primary: '#5C91FF',
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
  },
}
